module.exports = __webpack_public_path__ + "static/img/leiniao-benefit-listeningmusic.0ca3dc56.png";